import { ExistingSystemType } from 'data/types';
import { deleteEquipmentComponentPhotos } from 'utils/equipment-images';

export const REMOVE_SYSTEM_CONFIRM_TITLE = 'Remove this system?';

export const REMOVE_SYSTEM_CONFIRM_BUTTON_TEXT = 'Remove';

export function removeExistingSystemConfirmationMessage(
  system: ExistingSystemType
): string {
  const count = system.components.length;
  const noun = count === 1 ? 'piece of equipment' : 'pieces of equipment';
  return `${system.name} and its ${count} ${noun} will be removed. This cannot be undone.`;
}

export async function deleteExistingSystemPhotos(
  system: ExistingSystemType
): Promise<void> {
  await Promise.all(
    system.components.map((component) =>
      deleteEquipmentComponentPhotos(component)
    )
  );
}
